import { ReturnProcessingLevel } from "@redotech/redo-return-settings-primitives-common/return-processing-level";

export const sortingServiceLevel = [
  "verification",
  "grade",
  "license_plate",
  "quarantine",
] as const;
export type SortingServiceLevel = (typeof sortingServiceLevel)[number];

export const sortingServiceLevelDestinations: Record<
  SortingServiceLevel,
  string
> = {
  verification: "Verification",
  grade: "Grading",
  license_plate: "License Plate",
  quarantine: "Quarantine",
};

/**
 * Determines the sorting service level for a return based on the merchant's
 * configured return processing level. Defaults to verification when the
 * processing level is not set.
 */
export function determineSortingServiceLevel(
  returnProcessingLevel: ReturnProcessingLevel | undefined,
): SortingServiceLevel {
  switch (returnProcessingLevel) {
    case ReturnProcessingLevel.GRADING:
    case ReturnProcessingLevel.REFURBISHING:
      return "grade";
    case ReturnProcessingLevel.VERIFICATION:
    case ReturnProcessingLevel.REPACKING:
      return "verification";
    default:
      return "verification";
  }
}

export function getDestinationForServiceLevel(
  level: SortingServiceLevel,
): string {
  return sortingServiceLevelDestinations[level];
}
